import { jsx } from 'react/jsx-runtime';
import { cva, cx } from 'class-variance-authority';

const overlayStyles = cva([
    "mci-fixed mci-inset-0 mci-size-full mci-bg-black/50 mci-transition-opacity mci-duration-default",
], {
    variants: {
        isVisible: {
            true: ["mci-pointer-events-auto"],
            false: ["mci-pointer-events-none mci-opacity-0"],
        },
    },
});
const Overlay = ({ className, isVisible }) => (jsx("div", { className: cx(overlayStyles({ isVisible }), className) }));

export { Overlay };
